// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"34a67355","361":"d11cee69","369":"8709b7a4","453":"f2ceef12","495":"9328bd43","691":"2068a371","751":"79bf4b85","805":"5f524945"}[chunkId] + ".chunk.js";
};